import { createAction, createReducer } from "redux-act";
import produce from "immer";
import { GeocodeResultDc } from "@evergis/api";
import { reducerRegistry } from "../reducerRegistry";

export type GeocodeState = {
  items?: GeocodeResultDc[];
};

export const reducerName = "geocode";
const initialState: GeocodeState = {};

export const setGeocodeItems = createAction<GeocodeState["items"]>("geocode/set-items");
export const reset = createAction("geocode/reset");
export const reducer = createReducer({}, initialState);

reducer.on(
  setGeocodeItems,
  produce((state: GeocodeState, items: GeocodeState["items"]) => {
    state.items = items;
  }),
);

reducer.on(reset, () => initialState);

reducerRegistry.register(reducerName, reducer);
